import { Icon, Text, type IconSize } from "@salestrak/ui";

import {
  DROPDOWN_MENU_PARTS,
  type IssueMenuParts,
} from "#app/components/issue-actions/issue-menu-items";
import { useAutomationsDialogActions } from "#app/lib/automations-dialog-context";
import type { Omittable } from "@salestrak/ui";

// The per-stage "Automate stage" entry shared by the board column menu and
// the table stage-group menu — opens the automations dialog seeded with a
// Stage-changed trigger pinned to this stage. Gating stays with the caller
// (`useAutomateStage`) so each surface can also skip its separators.
//
// Base UI ships a component per menu kind, so the item takes its part set from
// the host (`parts`) rather than picking a primitive itself — the shared
// `IssueMenuParts` record. Both current hosts are dropdown menus, which is the
// default.
export function AutomateStageMenuItem({
  workflowId,
  stageId,
  iconSize,
  parts = DROPDOWN_MENU_PARTS,
}: Omittable<{
  workflowId: string;
  stageId: string;
  /** Match the sibling menu items' icon size on the host surface. */
  iconSize: IconSize;
  /** Menu part set of the hosting menu kind. Defaults to the dropdown parts. */
  parts?: IssueMenuParts;
}>) {
  const { openDialog } = useAutomationsDialogActions();
  return (
    <parts.Item
      onClick={() =>
        openDialog({ type: "automate-stage", workflowId, stageId })
      }
    >
      <Icon name="zap" size={iconSize} />
      <Text size="sm">Automate stage</Text>
    </parts.Item>
  );
}
